import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask w-full h-full"
}
const _hoisted_2 = { class: "modal-body mtop-10" }
const _hoisted_3 = { class: "row w-full" }
const _hoisted_4 = { class: "col-0-8 colend mright-04" }

import { ref, watch } from "vue";
import {onClickOutside} from '@vueuse/core'
import { useI18n } from 'vue-i18n';
import { ApiError, CreateDayModelRequest, DayModelLightResponse, SettingsApi } from '@/apiGenerate/medserver';
import { toastError, toastSuccess } from "@/utils/toast-utils";
import { useToast } from "primevue";
import { medServerApiConfig } from "@/config/medserver-api.config";


export default /*@__PURE__*/_defineComponent({
  __name: 'esDayModelForm',
  props: {
    isOpen: { type: Boolean },
    header: {},
    currentPersonId: {},
    selectedHealthProId: {},
    selectedInstituteId: {}
  },
  emits: ["modal-close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const { t } = useI18n();
const toast = useToast();

const settingsApi = new SettingsApi(medServerApiConfig);

const target = ref(null);

const createDayModelRequest = ref<CreateDayModelRequest>({
  dayModelName:''
});

onClickOutside(target, ()=>emit('modal-close'));

const confirmFormModal = async () => {
  if (createDayModelRequest.value && (props.currentPersonId || props.selectedHealthProId)) {
    await settingsApi.createDayModelByInstitute({instituteId: props.selectedInstituteId, 
                                                createDayModelRequest: createDayModelRequest.value,
                                                doctorId: props.selectedHealthProId ? props.selectedHealthProId : props.currentPersonId}).then((dayModelCreated: DayModelLightResponse) => {
      emit('modal-close', dayModelCreated);
      toastSuccess(toast, {
          summary: t('common.toast.success.add'),
          detail:  t('settings.label.dayModel.form.message.success.add')
      });
    }).catch((error: ApiError) => {
      toastError(toast, {
          summary: t('common.toast.error'),
          detail: error?.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      });      

      // Throw error to set at false the var __alreadyClicked in v-one-click directive
      throw error;
    });
  }
}

const closeFormModal = () => {
    emit('modal-close');
}

watch(
    () => props.isOpen,
  () => {
    createDayModelRequest.value = {
      dayModelName:''
    }
  }
);


return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_inputBox = _resolveComponent("inputBox")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "modal-container-day-model",
          ref_key: "target",
          ref: target
        }, [
          _createVNode(_component_es_modal_header, { header: _ctx.header }, null, 8, ["header"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_text_item, {
                  txt: _unref(t)('settings.label.dayModel.form.name'),
                  styles: "main-m"
                }, null, 8, ["txt"])
              ]),
              _createVNode(_component_inputBox, { class: "col-1-5 w-full" }, {
                default: _withCtx(() => [
                  _createVNode(_component_inputLineNew2, {
                    modelValue: createDayModelRequest.value.dayModelName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((createDayModelRequest.value.dayModelName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_es_modal_footer, {
            onModalCancel: closeFormModal,
            confirmModalMethod: async () => await confirmFormModal()
          }, null, 8, ["confirmModalMethod"])
        ], 512)
      ]))
    : _createCommentVNode("", true)
}
}

})